import { NzrAvatar } from "../../avatar/nzr-avatar";
import styles from "./identity-control.module.css";

/**
 * The rail's own 40x40 hit-target/hover box (design.md's "square avatar"
 * convention, sized to match `<NavRailItem>`'s `.itemIconBox` exactly —
 * see identity-control.module.css's own comments on why it's 40x40 with a
 * smaller 24x24 glyph inside, not a full-bleed 40x40 image) wrapping the
 * shared `<NzrAvatar>` for the actual image/initials rendering. Used to
 * duplicate that rendering locally; now delegates to
 * `../../avatar/nzr-avatar.tsx` so the rail, /profile, and the admin
 * notifications table all render the exact same avatar recipe.
 */
export function RailAvatar({
  name,
  imageUrl,
}: {
  name: string;
  imageUrl?: string | null;
}) {
  return (
    <span className={styles.avatar} aria-hidden="true">
      <NzrAvatar name={name} imageUrl={imageUrl} size={24} />
    </span>
  );
}
